const {v4: uuidv4} = require('uuid')
const generateCallId = () => {
  return uuidv4().replace(/-/g, '') 
}

export default generateCallId
